import config from "../config/index";
import labels from "../config/labels";
import { updateSessionStorage } from "../utils/helperServices";
import { Router } from "../components/atoms/DependencyHelper";

const env = config.env;
const urlPrefix = config.envConfigs[env].shoppingUrlPrefix;

export const upgradeStages = Object.freeze({
  NUMBER_ENRTY: labels.upgrade.stages.lbl_number_entry,
  OTP_ENRTY: labels.upgrade.stages.lbl_otp_entery,
  NUMBER_SELECT: labels.upgrade.stages.lbl_number_select,
  UPGRADE_RESULT: labels.upgrade.stages.lbl_upgrade_result,
  TECHNICAL_ERROR: labels.upgrade.stages.lbl_technical_error,
  ELIGIBLE_NUMBER_SELECT: labels.upgrade.stages.lbl_eligible_number_select,
});

export const errorCodes = {
  user_not_found: labels.upgrade.errorCodes.code_user_not_found,
  invalid_otp_error: labels.upgrade.errorCodes.code_invalid_otp_error,
  otp_service_down: labels.upgrade.errorCodes.code_otp_service_down,
  service_down: labels.upgrade.errorCodes.code_service_down,
  logged_user_service_down:
    labels.upgrade.errorCodes.code_logged_user_service_down,
  user_acc_error: labels.upgrade.errorCodes.code_user_acc_error,
  code_otp_no_alternative: labels.upgrade.errorCodes.code_otp_no_alternative,
};

export const checkifUpgradableAndC3D = (resultCode) => {
  if (
    resultCode === labels.upgrade.errorCodes.code_mah_user_upgradable ||
    resultCode === labels.upgrade.errorCodes.code_child_user_upgradable
  ) {
    return true;
  }
  return false;
};

export const checkChildUpgradable = (resultCode) => {
  if (resultCode === labels.upgrade.errorCodes.code_child_user_upgradable) {
    return true;
  }
  return false;
};

export const checkIfHiddenDropdown = (resultCode) => {
  switch (resultCode) {
    case "upgradeeligibility_bus_mah":
    case "upgradeeligibility_bus_child":
    case "upgradeeligibility_bus_na":
    case "upgradeeligibility_legacycustomer":
    case "upgradeeligibility_bus_na_001":
    case "upgradeeligibility_c3d_na_004":
    case "upgradeeligibility_c3d_mah_004":
    case "upgradeeligibility_c3d_child_004":
      return true;
    default:
      return false;
  }
};
export const checkUserNextDueDateforUpgrade = (resultCode) => {
  if (
    resultCode &&
    (resultCode.includes(labels.upgrade.errorCodes.code_user_duefor_upgrade) ||
      resultCode === labels.upgrade.errorCodes.code_cbu_staff_not_eligible)
  ) {
    return true;
  }
  return false;
};

export const maskMsisdn = (msisdn) => {
  let tempMsisdn = msisdn;
  if (RegExp(/^27[0-9]*$/).test(msisdn)) {
    tempMsisdn = msisdn?.replace(msisdn.substring(0, 2), "0");
  }
  const maskedMsisdn = tempMsisdn?.replace(tempMsisdn.substring(3, 7), "****");
  return maskedMsisdn;
};

export const fetchAffordCode = (path) => {
  if (path.includes("/shopping/product-details")) {
    return labels.upgrade.errorCodes.code_product_not_affordable;
  } else if (path.includes("/shopping/deal-details-page")) {
    return labels.upgrade.errorCodes.code_deal_not_affordable;
  }
  return labels.upgrade.errorCodes.code_deal_not_affordable;
};

export const checkIfFromDetailPage = (path) => {
  if (
    path.includes("/shopping/product-details") ||
    path.includes("/shopping/deal-details-page")
  ) {
    return true;
  }
  return false;
};

export const checkIfFromDealDetailPage = (path) => {
  if (path.includes("/shopping/deal-details-page")) {
    return true;
  }
  return false;
};

export const resetFiltersOnStopUpgrade = (path) => {
  const resetFilterData = (pathValue) => {
    Router.push(pathValue, pathValue, { shallow: true }).then(() => {
      if (typeof window !== "undefined") {
        window.location.reload();
      }
    });
  }

  let newPathRef;
  switch(path) {
    case `${urlPrefix}/deals` : {
      newPathRef = `${urlPrefix}/deals`;
      resetFilterData(newPathRef);
      return;
    }
    case `${urlPrefix}/products` : {
      newPathRef = `${urlPrefix}/products`;
      resetFilterData(newPathRef);
      return;
    }
    case `${urlPrefix}/deal-selection/[id]` : {
      const asPathRouter = Router?.asPath;
      const parseObjectData = JSON.parse('{"' + decodeURI(asPathRouter).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
      const urlData = `${Object.keys(parseObjectData)[0]}=${Object.values(parseObjectData)[0]}${parseObjectData["buyOption"]? "buyOption=" + parseObjectData["buyOption"]:""}`;
      newPathRef = urlData;
      resetFilterData(newPathRef);
      return;
    }
    default: {
      return;
    }
  }
};

export const legacySessionData = [
  "legacyAllowed",
  "childAllowed",
  "isOtherNumber",
  "collectAtStore",
  "upgradeMsisdn",
  "isC3dUser",
  "mah",
  "upgradeType",
  "journey",
];

export const handoverUpgradeeSession = (
  canReciveOTP,
  isChildAllowed,
  upgradeResponse
) => {
  let legacyAllowed = config.legacyAllowed;
  let collectAtStore = config.collectAtStore;
  let tempMsisdn = upgradeResponse?.msisdn;
  if (RegExp(/^27[0-9]*$/).test(upgradeResponse?.msisdn)) {
    tempMsisdn = upgradeResponse?.msisdn.replace(
      upgradeResponse.msisdn.substring(0, 2),
      "0"
    );
  }
  const legacyData = {
    legacyAllowed: legacyAllowed,
    collectAtStore: collectAtStore,
    isOtherNumber: !canReciveOTP,
    childAllowed: isChildAllowed,
    upgradeType: upgradeResponse.upgradeType,
    mah: upgradeResponse.mah,
    upgradeMsisdn: `${tempMsisdn}`,
    isC3dUser: upgradeResponse.c3dCustomer,
    journey: upgradeResponse.c3dCustomer ? "C3D" : "Legacy",
  };
  Object.keys(legacyData).forEach((key) => {
    updateSessionStorage(
      key,
      legacyData[key],
      !legacyData[key] === "upgradeMsisdn"
    );
  });
};


export const newMaskMsisdn = (msisdn) => {
  let tempMsisdn = msisdn;
  if (RegExp(/^27[0-9]*$/).test(msisdn)) {
    tempMsisdn = msisdn?.replace(msisdn.substring(0, 2), "0");
  }
  const maskedMsisdn = tempMsisdn?.replace(tempMsisdn.substring(3, 6), "***");
  return maskedMsisdn;
};
